// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__3YFp5","spinning":"spinner_spinning__3eiu_"};